import React from "react";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Mariana S.",
    role: "Paciente — Enxaqueca crônica",
    rating: 5,
    text: "Convivi com enxaquecas semanais por anos. Depois do tratamento conduzido pela Dra. Luz Adriana, minha rotina mudou — voltei a planejar a vida sem medo da próxima crise.",
  },
  {
    name: "Carlos R.",
    role: "Paciente — Cefaleia cervicogênica",
    rating: 5,
    text: "Atendimento extremamente atencioso e técnico. Pela primeira vez senti que minha dor foi realmente investigada. O alívio veio acompanhado de explicação clara em cada etapa.",
  },
  {
    name: "Beatriz L.",
    role: "Paciente — Dor muscular crônica",
    rating: 5,
    text: "Recomendo de coração. A Dra. trata o paciente como pessoa, não como diagnóstico. O resultado do tratamento superou minhas expectativas.",
  },
];

export const Testimonials = () => {
  return (
    <section id="depoimentos" data-testid="testimonials-section" className="py-20 sm:py-24 lg:py-32 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="max-w-3xl">
          <p className="overline text-[#D4AF37] mb-5">Pacientes que voltaram a viver</p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#0A2540] leading-tight tracking-tight">
            Depoimentos de quem encontrou alívio
          </h2>
          <p className="mt-6 text-[#1A1A1A]/70 leading-relaxed text-lg">
            Histórias reais que refletem o compromisso com cuidado, técnica e
            resultado.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((t, i) => (
            <article
              key={t.name}
              data-testid={`testimonial-card-${i}`}
              className="card-lift bg-white border border-[#E9ECEF] rounded-lg p-8 relative"
            >
              <Quote className="w-8 h-8 text-[#D4AF37]/40 absolute top-6 right-6" />
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star key={idx} className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" />
                ))}
              </div>
              <p className="text-[#1A1A1A]/80 leading-relaxed text-[15px]">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-6 pt-5 border-t border-[#E9ECEF]">
                <p className="text-xs text-[#6C757D]">{t.role}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
